// extracted by mini-css-extract-plugin
export default {"Container":"Index_Container__Y4RLl","CardContainer":"Index_CardContainer__rxERz"};